<template>
	<footer :class="show ? 'h5' : ''">	
		<div class="footer-center Gwidth">
			<div class="logoBox">
				<img src="@/assets/img/slog.png" alt="" class="logo"/>
				<div class="txt">Copyright 2025-2026 星润科技 All Rights Reserved</div>
			</div>
			<div class="footer-center-left">
				<div class="footer-center-left-item">
					<h5>服务支持</h5>
					<ul>
						<li class="alink" @click="toOpen('/help.html')"><a href="/help.html">帮助中心</a></li>
						<li class="alink"  @click="toOpen('/down.html')"><a href="/down.html">下载中心</a></li>
						<li class="alink"  @click="toOpens('https://partner.biandianyun.com/agreement.html')"><a href="https://partner.biandianyun.com/agreement.html">用户协议</a></li>
						<li class="alink"  @click="toOpen('/open.html')"><a href="/open.html">开放平台</a></li>
					</ul>
				</div>
				<div class="footer-center-left-item">
					<h5>友情链接</h5>
					<ul>					
						<li class="alink"  @click="toOpens('https://www.xingrunkeji.cn/')"><a href="https://www.xingrunkeji.cn/">星润科技</a></li>
					</ul>
				</div>
				<div class="footer-center-left-item">
					<h5>联系我们</h5>
					<ul>
						<li class="alink"  @click="toOpen('/about.html')"><a href="/about.html">关于我们</a></li>
						<li class="alink"  @click="toOpen('/business.html')"><a href="/business.html">商务合作</a></li>
					</ul>
				</div>
				
			</div>
			<div class="footer-center-right">
				
				<div class="footer-center-right-item">
					<div class="gzh">
						<div class="img">
							<img src="@/assets/img/xcx.png" alt="" />
						</div>
						<p class="title">小程序</p>
					</div>
				</div>
				<div class="footer-center-right-item">
					<div class="gzh">
						<div class="img">
							<img src="@/assets/img/gzh.png" alt="" />
						</div>
						<p class="title">公众号</p>
					</div>
				</div>
				<div class="footer-center-right-item">
					<div class="gzh">
						<div class="img">
							<img src="@/assets/img/wx.png" alt="" />
						</div>
						<p class="title">商务合作</p>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom Gwidth">
			<div class="footer-bottom-ico">
				<img src="@/assets/images/footer.png" alt="" />
			</div>
			<div class="optxt">
				COPYRIGHT@北京星润时代网络科技有限公司 2013-2026 <a class="ahref" href="https://beian.miit.gov.cn/">京ICP备14055839号-14 </a>站长工具 
				<a class="ahref" href="https://www.xingrunkeji.cn/index/icp.pdf"
					>京网公安备：11011502005462号
				</a>
				增值电信业务经营许可证：B-20235590
			</div>
		
		</div>
	</footer>
</template>
<script>
	export default {
		name:"footer_bdy",
		data() {
			return {
				show:false,
			};
		},
		mounted() {
			if (this._isMobile()) {
			this.show = true;
			} else {
			this.show = this.$store.getters.phone;
			}
		},
		methods:{
			toOpen(val){
				this.$store.commit("ChangeCurrNav", val);
				if (val == this.$route.path) {
					return;
				}				
				// this.$router.push({ path: val });
			},
			toOpens(val){
				window.open(val)
			},
			_isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pod|iPhone|iPod|ios|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
		}
	};
</script>
<style lang="scss" scoped>
	@media screen and (min-width: 0px) {
		footer {
			padding: 0px 0 40px 0;
			background: #202123;
			.Gwidth{
				overflow: auto;
			}
			.smtop{
				width: 100%;
				padding-top: 30px;
				background: #ffffff;
			}
			.footer-center {
				padding: 30px 0;
				align-items: flex-start;
				.logoBox{
					display: flex;
					align-items: center;
					flex-direction: column;
					margin: 0 auto;
					padding-bottom: 30px;
					.logo{
						width: 110px;
						height: 110px;
					}
					.txt{
						font-size: 12px;
						color: #9697A1;
						margin-top: 9px;
					}
				}
				&-left {
					display: flex;
					align-items: flex-start;
					justify-content: space-between;
					padding-bottom: 30px;
					&-item {
						h5 {
							font-size: 14px;
							font-weight: 600;
							color: #ffffff;
							line-height: 20px;
							position: relative;
						
						}
						ul {
							margin-top: 10px;
							li {
								font-size: 14px;
								font-weight: 400;
								color: #9697A1;
								line-height: 28px;
								cursor: pointer;
								a{
									color: #9697A1;
								}
							}
						}
					}
				}
				&-right {
					// padding-top: 30px;
					display: flex;
					align-items: flex-end;
					justify-content: space-between;
					&-item {
						width: 50%;
						text-align: center;
						margin-bottom: 10px;
						&:nth-child(1) {
							width: 50%;
						}
						h5 {
							font-size: 14px;
							font-weight: 400;
							color: #1d2129;
							text-align: left;
						}
						.gzh {
							img {
								width: 90px;
								height: 90px;
								margin: 0 7px;
							}
							.title {
								font-size: 12px;
								font-weight: 400;
								color: #ffffff;
							}
							.des {
								font-size: 14px;
								font-weight: 400;
								color: #646566;
							}
						}
						.phone {
							img {
								width: 28px;
								height: 28px;
							}
							.title {
								font-size: 16px;
								font-weight: 500;
								color: #ffffff;
							}
							a {
								display: block;
								width: 100%;
								max-width: 192px;
								height: 36px;
								background: #2e51fb;
								margin: 0 auto;
								margin-top: 24px;
								font-size: 14px;
								line-height: 36px;
								font-weight: 400;
								color: #ffffff;
							}
							margin-bottom: 10px;
						}
					}
				}
			}
			.footer-links {
				padding: 16px 0;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				h5 {
					font-size: 14px;
					font-weight: 400;
					color: #ffffff;
					margin-bottom: 10px;
				}
				a {
					font-size: 14px;
					font-weight: 400;
					color: #ffffff;
					margin-right: 24px;
					margin-bottom: 10px;
				}
			}
			.footer-bottom {
				border-top: 1px solid #767676;
				padding-top: 16px;
				font-size: 14px;
				font-weight: 400;
				color: #ffffff;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				a {
					color: #646566;
				}
				&-ico {
					img {
						width: 100px;
						height: auto;
						margin-right: 10px;
						&:nth-child(2) {
							width: 98px;
							height: 31px;
						}
					}
				}
				.optxt{
					// line-height: 34px;
					font-size: 10px;
					// white-space: nowrap;
					color: #646566;
				}
			}
		}
	}
	@media screen and (min-width: 760px) {
		footer {
			.footer-top {
				li {
					width: auto;
					margin-bottom: 20px;
				}
			}
		}
	}
	@media screen and (min-width: 820px) {
		footer {
			.footer-center {
				display: flex;
				justify-content: space-between;
				&-left {
					width: calc(50% - 20px);
					border-bottom: 0;
					padding-bottom: 0px;
					position: relative;
					
				}
				&-right {
					width: calc(50% - 20px);
					padding-top: 0px;
					flex-wrap: nowrap;
				}
			}
		}
	}
	@media screen and (min-width: 1100px) {
	}
	@media screen and (min-width: 1300px) {
		footer {
			.footer-center {
				.logoBox{
					width: 177px;
					margin: 0;
					.logo{
						width: 74px;
						height: 74px;
					}
				}
				&-left {
					width: 424px;
					&::after {
						right: -70px;
					}
				}
				&-right {
					width: auto;
					&-item{
						.gzh{
						img {
								width: 120px;
								height: 120px;
								margin: 0 14px;
							}
						}
					}
				}
			}
		}
	}
</style>
